// export const emailRegex = new RegExp(/^((?!\.)[\w\-_.]{0,80}[^.])(@\w{1,10})(\.\w{1,10}(\.\w{1,10})?[^.\W])$/)
// export const phoneRegex = new RegExp(/^(([+][(]?\d{1,3}[)]?)|([(]?\d{2,4}[)]?))\s*[)]?[-\s.]?[(]?\d{1,3}[)]?([-\s.]?\d{3})([-\s.]?\d{2,4})$/)
export const activeEmailRegex = new RegExp(/^[\w@\._-]{0,50}$/)
export const activePhoneRegex = new RegExp(/^\d+$/)
export const fullNameRegex = new RegExp(/.{2,} .{2,}/)
export const phoneRegex = new RegExp(/^05\d+$/)
export const heTextRegex = new RegExp(/^[-,'"\.\d א-ת]*$/)
export const hebrewRegex = new RegExp(/^[-' א-ת]{2,} [-' א-ת]{2,}$|^$/)
export const hebrewAndSpecialCharsRegex = new RegExp(/^[\u0590-\u05FF0-9]+[\u0590-\u05FF0-9 ,./:!()\\|?'"-]*$/);
export const hebrewFullNameRegex = new RegExp(/^[\u0590-\u05FF]{2,}[\u0590-\u05FF '"]* [\u0590-\u05FF]{2,}[\u0590-\u05FF '"]*$/);
export const urlRegex = new RegExp(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);
export const numbersRegex = new RegExp(/^[1-9]+[0-9]*$/);
export const numberStringRegex = new RegExp(/^[0-9]+$/)
